import React from 'react';
import posed from 'react-pose';

const InterTitle=posed.h1(
    { 
        initialPose:{opacity:0,x:-200},
        visible:{opacity:1,x:0},
        hidden:{opacity:0,x:-200},
        moveIn:{x:0},
        moveOut:{x:-50},
        transition: { duration: 1000}
    }
)
const Title= props => {
    let pose;
    if(props.alpha){
         pose=props.pose?'visible':'hidden'
    }else{
         pose=props.pose?'moveIn' : 'moveOut'
    }
    return(
        <InterTitle pose={pose} className={props.className}>{props.content}</InterTitle>
    )
}
export default Title;